import { render, staticRenderFns } from "./SSelect.vue?vue&type=template&id=8a35c5ac&"
import script from "./SSelect.vue?vue&type=script&lang=js&"
export * from "./SSelect.vue?vue&type=script&lang=js&"
import style0 from "./SSelect.vue?vue&type=style&index=0&id=8a35c5ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports